import PropTypes from 'prop-types';
import useInvoice from 'Hooks/useInvoice';
import PreviewFile from 'Components/Molecules/PreviewFile/PreviewFile';
import InvoicePreviewFileUpload from './InvoicePreviewFileUpload';

const download = (url, fileName) => {
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const getFileName = (string) => {
    try {
        const url = new URL(string);
        const path = url.pathname;
        const fileName = path.split('/').pop();
        return fileName;
    } catch (error) {
        return '';
    }
};

export default function InvoicePreviewFileDesktop(props) {
    const { id, onUpload, className = 'h-screen' } = props;

    const { invoice, isLoading } = useInvoice(id);

    if (!isLoading && !invoice?.file_url) {
        return <InvoicePreviewFileUpload onUpload={onUpload} />;
    }

    return (
        <PreviewFile
            loading={isLoading}
            url={invoice?.file_url}
            className={className}
            onDownload={() => {
                const fileName = getFileName(invoice?.file_url);
                download(invoice?.file_url, fileName);
            }}
        />
    );
}

InvoicePreviewFileDesktop.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onUpload: PropTypes.func,
    compactMode: PropTypes.bool,
    className: PropTypes.string,
};
